(function () {

    'use strict';

    angular.module('app').controller('ShipmentsController', ShipmentsController);

    ShipmentsController.$inject = [
        'Shipments',
        '$routeParams',
        'ShipmentsSearchTable',
        'BreakBulkShipmentsTable',
        'ArchivedShipmentsTable',
        '$location',
        'Carrier',
        '$scope',
        'ConsolidatedShipmentsTable',
        'toastr',
        'CommonService',
        'ManifestService',
        'ClientService',
        '$q'
    ];

    function ShipmentsController(
        Shipments,
        $routeParams,
        ShipmentsSearchTable,
        BreakBulkShipmentsTable,
        ArchivedShipmentsTable,
        $location,
        Carrier,
        $scope,
        ConsolidatedShipmentsTable,
        toastr,
        CommonService,
        ManifestService,
        ClientService,
        $q
    ) {
        let defaultFilters = {};
        let presetfilter = angular.fromJson(localStorage.getItem('shipmentsFilter'));

        const tabs = [
            'shipments-search',
            'break-bulk-shipments',
            'consolidated-shipments',
            'archived-shipments'
        ];
        const vm = this;
        vm.serviceDetailsList = {};

        vm.changeTab = changeTab;
        vm.printThermalAndConsignmentNote = printThermalAndConsignmentNote;
        vm.printManifestDoc = printManifestDoc;
        vm.printCommercialInvoice = printCommercialInvoice;
        vm.requestShipmentDocs = requestShipmentDocs;

        init();

        function init() {
            vm.isloadingData = true;
            $q.all({companies: loadAvailableCompanies(), offices: loadAvailableOffices()}).then(data => {
                vm.availableOffices = data.offices;
                vm.availableCompanies = data.companies;
                removeShipmentsFilter();
                initTables();
                setActiveTab();
                vm.isloadingData = false;
            }).catch(error => {
                vm.isloadingData = false;
                toastr.error(error.message);
            });
        }

        function loadAvailableCompanies() {
            const defer = $q.defer();
            ClientService.Client.getAvailableCompany(data => {
               defer.resolve(data);
            }, error => {
                defer.reject(error);
            });
            return defer.promise;
        }

        function loadAvailableOffices() {
            const defer = $q.defer();
            ClientService.Client.getAvailableOffice(data => {
                defer.resolve(data);
            }, error => {
               defer.reject(error);
            });
            return defer.promise;
        }

        function removeShipmentsFilter() {
            localStorage.removeItem('shipmentsFilter');
            if (presetfilter) {
                defaultFilters = presetfilter;
            }

        }

        function initTables() {
            vm.shipmentTable = new ShipmentsSearchTable(defaultFilters, vm.availableOffices, vm.availableCompanies).tableData;
            vm.archivedShipmentsTable = new ArchivedShipmentsTable(defaultFilters).tableData;
            vm.breakBulkTable = new BreakBulkShipmentsTable(defaultFilters).tableData;
            vm.consolidatedShimentTable = new ConsolidatedShipmentsTable(defaultFilters).tableData;
        }

        function setActiveTab() {
            if ($routeParams != null) {
                let params = $routeParams;
                let index = vm.activeIndex = tabs.findIndex(tab => params.tab === tab);
                vm.activeIndex = index > -1 ? index : 0;
            }
        }

        function changeTab(index) {
            const searchParams = { tab: tabs[index] };
            if ($routeParams.createdDate) {
                searchParams.createdDate = searchParams;
            }
            vm.activeIndex = index;
        }

        function printThermalAndConsignmentNote() {
            const ids = getShipmentIds();
            if (ids.length < 1) {
                toastr.warning('No shipments selected', 'WARNING');
                return;
            }

            CommonService.printLabels(ids, false, () => {
                const successMessage = ' Thermal Label' + (ids.length === 1 ? '' : 's') + ' downloaded';
                toastr.success(ids.length + successMessage);
            });

            CommonService.printConsignmentNote(ids, () => {
                var ids = ' Consignment Note' + (ids.length === 1 ? '' : 's') + ' downloaded';
                toastr.success(ids.length + successMessage);
            });
        }

        function printManifestDoc() {
            const ids = getShipmentIds();
            if (ids.length < 1) {
                toastr.warning('No shipments selected', 'WARNING');
                return;
            }

            ManifestService.downloadMultipleDocument(ids, () => {
                var successMessage = ' Manifest' + (ids.length === 1 ? '' : 's') + ' downloaded';
                toastr.success(ids.length + successMessage);
            }, error => {
                toastr.error(error.message, 'Error');
            });
        }

        function printCommercialInvoice() {
            const ids = getShipmentIds();
            if (ids.length < 1) {
                toastr.warning('No shipments selected', 'WARNING');
                return;
            }

            Shipments.customsDoc(ids, () => {
                var successMessage = ' Commercial Invoice' + (ids.length === 1 ? '' : 's') + ' downloaded';
                toastr.success(ids.length + successMessage);
            }, error => {
                toastr.error('Can not print commercial invoice', 'Error');
            })
        }

        function requestShipmentDocs() {
            const ids = getShipmentIds();
            if (ids.length < 1) {
                toastr.warning('No shipments selected', 'WARNING');
                return;
            }

            Shipments.requestMultipleShipmentDocs(ids, () => {
                toastr.error('API not yet available', 'Error');
            });
        }

        function getShipmentIds() {
            let ids = [];
            switch (vm.activeIndex) {
                case 0:
                    ids = vm.shipmentTable.data.filter(shipment => shipment.isSelected).map(shipment => shipment.id);
                    break;
                case 1:
                    ids = vm.breakBulkTable.data.filter(shipment => shipment.isSelected).map(shipment => shipment.id);
                    break;
                case 2:
                    ids = vm.consolidatedShimentTable.data.filter(shipment => shipment.isSelected).map(shipment => shipment.id);
                    break;
                case 3:
                    ids = vm.archivedShipmentsTable.data.filter(shipment => shipment.isSelected).map(shipment => shipment.id);
                    break;
            }
            return ids;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/ShipmentsController.js